import React from "react";
import * as T from "./types";
import * as S from "./styles";
import C from "@assets/themes/colors";
import { AdditionalMetadataLiteral, AdditionalMetadaTypesArray, IAdditionalMetadata } from "@state/brandsImages/types";
import Input from "@components/Input";
import { cloneDeep, parseInt } from "lodash";
import { validateYear } from "@utils/brand";

const MetadataInputs: React.FC<T.IProps> = (props) => {

  const additionalMetadata = props.additionalMetadata ?? {};

  const inputId = (props.typeInfo.ids?.length ? props.typeInfo.ids[0] : "year") as AdditionalMetadataLiteral;
  const inputLabel = props.typeInfo.labels?.length ? props.typeInfo.labels[0] : "Year";

  const changeEvent = (e: React.ChangeEvent<HTMLInputElement>) => {
    let newAdditionalMetadata = cloneDeep(additionalMetadata);
    const targetValue = e.target.value;
    let value = newAdditionalMetadata[inputId];
    if (
      inputId === "year" && validateYear(targetValue) ||
      inputId === "model"
    ) {
      value = targetValue;
    }
    newAdditionalMetadata[inputId] = value;
    props.onChange(newAdditionalMetadata);
  }

  return(
    <S.Root>
      <S.Title>
        {inputLabel}
      </S.Title>
      <Input
        id={`metadata-input-${inputId}`}
        placeholder={`Enter ${inputLabel}`}
        handleChange={changeEvent}
        value={additionalMetadata[inputId] ?? ""}
        disabled={props.isSaving}
        style={{
          width: "250px",
          height: "46px"
        }}
        inputStyle={{
          color: C.BLACK,
        }}
        validationType={inputId === "year" ? "validate-numbers" : undefined}
      />
    </S.Root>
  )
}

export default MetadataInputs;